"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var js_expansion_1 = require("js-expansion");
function PlayerForm(_a) {
    var channel = _a.channel, dashboard = _a.dashboard, onClose = _a.onClose;
    var model = {
        id: null,
        email: '',
        channel_id: channel.id,
    };
    var _b = storybook_1.Helpers.useSave('backend', 'emails', model), ecaptures = _b[0], setEcaptures = _b[1], submitEcaptures = _b[2];
    var _c = react_1.useState(false), send = _c[0], setSend = _c[1];
    var _d = react_1.useState(false), sendApproved = _d[0], setSendApproved = _d[1];
    var _e = react_1.useState(false), close = _e[0], setClose = _e[1];
    var _f = react_1.useState(false), watched = _f[0], setWatched = _f[1];
    function onSubmit() {
        submitEcaptures().then(function (response) {
            if (!response.errors.length) {
                writeCookie();
                setTimeout(function () {
                    setSendApproved(true);
                    onClose();
                }, 2000);
            }
        });
    }
    function writeCookie() {
        var channels = js_expansion_1.Cookies.read('channels');
        channels = channels ? JSON.parse(channels) : [];
        channels.push(channel.id);
        js_expansion_1.Cookies.write('channels', JSON.stringify(channels));
        setSend(true);
    }
    function inCookie() {
        var channels = js_expansion_1.Cookies.read('channels');
        if (!channels) {
            return;
        }
        channels = JSON.parse(channels);
        if (channels.includes(channel.id)) {
            setWatched(true);
        }
    }
    react_1.useEffect(function () {
        inCookie();
    }, []);
    if (watched && !dashboard) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (sendApproved) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (close) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-ecaptures-player-form text-center inset-0 z-20' },
        react_1.default.createElement("div", { className: 'bg-dark pb-hd relative bg-cover bg-center h-full opacity-75' }),
        react_1.default.createElement("div", { className: 'storybook-ecaptures-player-form-wrapper' },
            react_1.default.createElement(storybook_1.Forms.Form, null,
                react_1.default.createElement("figure", { className: 'flex justify-center' },
                    react_1.default.createElement("img", { src: channel.logo, alt: 'logo', className: 'mb-4' })),
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2', className: 'mb-4' }, channel.options ? channel.options.ecapture_title : ''),
                react_1.default.createElement(storybook_1.Forms.Field, { className: 'mb-4 flex ml-auto' },
                    react_1.default.createElement(storybook_1.Forms.Input, { className: 'mb-2 text-black', placeholder: 'E-mailadres', value: ecaptures.data.email, onChange: function (email) { return setEcaptures({ email: email }); } }),
                    react_1.default.createElement(storybook_1.Forms.Buttons, { className: 'storybook-ecapture-player-submit', submit: onSubmit, errors: ecaptures.errors, loading: ecaptures.submitting, title: send ? 'Ingeschreven' : 'Inschrijven', approved: send })),
                react_1.default.createElement("span", { onClick: function () {
                        writeCookie();
                        setClose(true);
                    }, className: 'text-link cursor-pointer' }, "Nee, bedankt."))));
}
exports.default = PlayerForm;
